import React from 'react';

// Map of language -> unprefixed path for the current recipe, e.g.
// { lt: '/receptas/cepelinai/', en: '/recipe/potato-dumplings/' }.
// It is `null` on pages that are not recipe pages (home, 404, ...), where the
// locale switcher falls back to the i18n plugin's `originalPath` behaviour.
export type Translations = Record<string, string> | null;

const PageTranslationsContext = React.createContext<Translations>(null);

interface PageTranslationsProviderProps {
  translations: Translations;
  children: React.ReactNode;
}

export const PageTranslationsProvider: React.FC<PageTranslationsProviderProps> = ({
  translations,
  children,
}) => (
  <PageTranslationsContext.Provider value={translations ?? null}>
    {children}
  </PageTranslationsContext.Provider>
);

export const usePageTranslations = (): Translations =>
  React.useContext(PageTranslationsContext);
